import api from "./api";

export const reviewsservice = {

  // Récupérer les Reviews par ID de cours
  getReviewsByCourseId: async (courseId) => {
    try {
      const response = await api.get(`/reviews/course/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching reviews for course ${courseId}:`, error);
      throw error;
    }
  },

  // Récupérer toutes les Reviews
  getAllReviews: async () => {
    try {
      const response = await api.get("/reviews");
      return response.data;
    } catch (error) {
      console.error("Error fetching Reviews:", error);
      throw error;
    }
  },

  // Récupérer une Reviews par ID
  getReviewsById: async (id) => {
    try {
      const response = await api.get(`/reviews/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching Reviews ${id}:`, error);
      throw error;
    }
  },

  // Créer une nouvelle Reviews
  createReviews: async (reviewsData) => {
    try {
      const response = await api.post("/reviews", reviewsData);
      return response.data;
    } catch (error) {
      console.error("Error creating Reviews:", error);
      throw error;
    }
  },

  // Mettre à jour une Reviews
  updateReviews: async (id, reviewsData) => {
    try {
      const response = await api.put(`/reviews/${id}`, reviewsData);
      return response.data;
    } catch (error) {
      console.error(`Error updating Reviews ${id}:`, error);
      throw error;
    }
  },

  // Supprimer une Reviews
  deleteReviews: async (id) => {
    try {
      const response = await api.delete(`/reviews/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting Reviews ${id}:`, error);
      throw error;
    }
  },
};
